import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  bypass_reason: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .trim()
    .min(20, i18n.t('MIN_LENGTH_KEY', { value: 20 }))
    .max(
      100,
      i18n.t('REQUIRE_MAX_LENGTH_TEXT_KEY', {
        max_length: 100,
      })
    ),
});
